import { createMuiTheme } from '@material-ui/core/styles';

export const theme = (primaryColor) => createMuiTheme({
    typography: {
        fontFamily: [
            'Noto Sans JP, sans-serif',
            'Roboto',
            'Questrial, sans-serif',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
    },
    palette: {
        primary: {
            main: primaryColor ? primaryColor : "#335eea",
            // main: "#335eea",
            // main: "#7f2bef",
            // main: "#5B10FF",
        },
        secondary: {
            main: "#ea2957",
        },
    },
    custom: {
        skillItemBackground: "#EAEFFD"
    },
    overrides: {
        MuiButton: {
            containedPrimary: {
                color: 'white',
            },
        },
    }
});
